import React from "react";

function NotFoundImage() {
  return (
    <svg
      width="220"
      height="185"
      viewBox="0 0 650 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className=""
    >
      <path
        d="M608.904 226.127V207.936C608.904 204.467 607.526 201.14 605.073 198.687C602.62 196.234 599.294 194.856 595.825 194.856H549.659C547.941 194.856 546.24 194.518 544.653 193.861C543.067 193.203 541.625 192.24 540.41 191.025C539.196 189.811 538.232 188.369 537.575 186.782C536.918 185.195 536.579 183.494 536.579 181.777V163.586C536.579 161.868 536.918 160.167 537.575 158.58C538.232 156.993 539.196 155.551 540.41 154.337C541.625 153.122 543.067 152.159 544.653 151.502C546.24 150.844 547.941 150.506 549.659 150.506H551.116C554.585 150.506 557.912 149.128 560.365 146.675C562.818 144.222 564.196 140.896 564.196 137.427V119.235C564.196 115.767 562.818 112.44 560.365 109.987C557.912 107.534 554.585 106.156 551.116 106.156H129.209C125.74 106.156 122.414 107.534 119.961 109.987C117.508 112.44 116.13 115.767 116.13 119.235V137.427C116.13 140.896 117.508 144.222 119.961 146.675C122.414 149.128 125.74 150.506 129.209 150.506C132.678 150.506 136.005 151.884 138.458 154.337C140.911 156.79 142.289 160.117 142.289 163.586V181.777C142.289 185.246 140.911 188.572 138.458 191.025C136.005 193.478 132.678 194.856 129.209 194.856H78.6299C75.161 194.856 71.8342 196.234 69.3813 198.687C66.9285 201.14 65.5504 204.467 65.5504 207.936V226.127C65.5504 229.596 66.9285 232.922 69.3813 235.375C71.8342 237.828 75.161 239.206 78.6299 239.206H98.4765C100.194 239.206 101.895 239.545 103.482 240.202C105.069 240.859 106.511 241.823 107.725 243.037C108.94 244.252 109.903 245.693 110.56 247.28C111.218 248.867 111.556 250.568 111.556 252.286V270.477C111.556 272.195 111.218 273.895 110.56 275.482C109.903 277.069 108.94 278.511 107.725 279.725C106.511 280.94 105.069 281.903 103.482 282.561C101.895 283.218 100.194 283.556 98.4765 283.556H98.4285C94.9596 283.556 91.6328 284.934 89.18 287.387C86.7271 289.84 85.3491 293.167 85.3491 296.636V314.827C85.3491 316.544 85.6874 318.245 86.3447 319.832C87.002 321.419 87.9654 322.861 89.18 324.075C90.3945 325.29 91.8364 326.253 93.4233 326.911C95.0101 327.568 96.7109 327.906 98.4285 327.906H101.3C104.769 327.906 108.096 329.284 110.549 331.737C113.001 334.19 114.379 337.517 114.379 340.986V359.177C114.379 362.646 113.001 365.973 110.549 368.426C108.096 370.879 104.769 372.257 101.3 372.257H54.1754C50.7065 372.257 47.3797 373.635 44.9268 376.087C42.474 378.54 41.0959 381.867 41.0959 385.336V403.527C41.0959 405.245 41.4342 406.945 42.0915 408.532C42.7489 410.119 43.7123 411.561 44.9268 412.776C46.1414 413.99 47.5832 414.954 49.1701 415.611C50.757 416.268 52.4578 416.607 54.1754 416.607H558.138C559.856 416.607 561.557 416.268 563.144 415.611C564.731 414.954 566.172 413.99 567.387 412.776C568.602 411.561 569.565 410.119 570.222 408.532C570.88 406.945 571.218 405.245 571.218 403.527V385.336C571.218 383.618 570.88 381.918 570.222 380.331C569.565 378.744 568.602 377.302 567.387 376.087C566.172 374.873 564.731 373.909 563.144 373.252C561.557 372.595 559.856 372.256 558.138 372.256H546.798C543.329 372.256 540.002 370.878 537.549 368.426C535.096 365.973 533.718 362.646 533.718 359.177V340.986C533.718 337.517 535.096 334.19 537.549 331.737C540.002 329.284 543.329 327.906 546.798 327.906H573.538C575.255 327.906 576.956 327.568 578.543 326.911C580.13 326.253 581.572 325.29 582.786 324.075C584.001 322.861 584.964 321.419 585.622 319.832C586.279 318.245 586.617 316.544 586.617 314.827V296.636C586.617 293.167 585.239 289.84 582.786 287.387C580.333 284.934 577.007 283.556 573.538 283.556H565.426C563.709 283.556 562.008 283.218 560.421 282.561C558.834 281.903 557.392 280.94 556.178 279.725C554.963 278.511 554 277.069 553.342 275.482C552.685 273.895 552.347 272.195 552.347 270.477V252.286C552.347 250.568 552.685 248.867 553.342 247.28C554 245.693 554.963 244.252 556.178 243.037C557.392 241.823 558.834 240.859 560.421 240.202C562.008 239.545 563.709 239.206 565.426 239.206H595.825C599.294 239.206 602.62 237.828 605.073 235.375C607.526 232.922 608.904 229.596 608.904 226.127Z"
        fill="#E8E8E8"
      />
      <path
        d="M456.233 237.525H488.536"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M456.233 246.835H488.536"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M456.233 256.146H488.536"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M402.504 158.486H144.464C137.284 158.486 131.464 164.306 131.464 171.486V365.806C131.464 372.986 137.284 378.806 144.464 378.806H402.504C409.684 378.806 415.504 372.986 415.504 365.806V171.486C415.504 164.306 409.684 158.486 402.504 158.486Z"
        fill="white"
      />
      <path
        d="M385.272 180H160.997C156.028 180 152 184.028 152 188.997V349.923C152 354.892 156.028 358.92 160.997 358.92H385.272C390.241 358.92 394.269 354.892 394.269 349.923V188.997C394.269 184.028 390.241 180 385.272 180Z"
        fill="#D3D3D3"
      />
      <path
        d="M240.224 204.206H187.224C183.822 204.206 181.064 206.964 181.064 210.366V246.286C181.064 249.688 183.822 252.446 187.224 252.446H240.224C243.626 252.446 246.384 249.688 246.384 246.286V210.366C246.384 206.964 243.626 204.206 240.224 204.206Z"
        fill="#E8E8E8"
      />
      <path
        d="M363.524 287.006H310.524C307.122 287.006 304.364 289.764 304.364 293.166V329.086C304.364 332.488 307.122 335.246 310.524 335.246H363.524C366.926 335.246 369.684 332.488 369.684 329.086V293.166C369.684 289.764 366.926 287.006 363.524 287.006Z"
        fill="#E8E8E8"
      />
      <path
        d="M311.464 254.967V265.907C311.464 267.07 311.235 268.222 310.79 269.297C310.345 270.372 309.692 271.349 308.869 272.172C308.046 272.994 307.07 273.647 305.995 274.092C304.92 274.537 303.768 274.767 302.604 274.767H205.484C203.134 274.767 200.881 275.7 199.219 277.362C197.558 279.023 196.624 281.277 196.624 283.627C196.624 285.976 197.558 288.23 199.219 289.892C200.881 291.553 203.134 292.487 205.484 292.487H248.964C251.314 292.487 253.568 293.42 255.229 295.082C256.891 296.743 257.824 298.997 257.824 301.347V302.267C257.824 303.43 258.053 304.582 258.499 305.657C258.944 306.732 259.597 307.709 260.419 308.532C261.242 309.354 262.219 310.007 263.294 310.452C264.369 310.897 265.521 311.127 266.684 311.127H304.364"
        stroke="#E3E3E3"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M415.504 271.286H438.984C441.334 271.286 443.588 272.22 445.249 273.881C446.911 275.543 447.844 277.797 447.844 280.146V281.066C447.844 282.23 448.074 283.382 448.519 284.457C448.964 285.532 449.617 286.509 450.439 287.331C451.262 288.154 452.239 288.807 453.314 289.252C454.389 289.697 455.541 289.926 456.704 289.926H474.384"
        stroke="#D3D3D3"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M246.384 225.447H302.604C304.954 225.447 307.208 226.38 308.869 228.042C310.531 229.703 311.464 231.957 311.464 234.307V242.367"
        stroke="#E3E3E3"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M304.364 242.366H318.304"
        stroke="#E3E3E3"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M304.364 254.966H318.304"
        stroke="#E3E3E3"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M487.851 294.046H497.824"
        stroke="#D3D3D3"
        stroke-width="4"
        stroke-miterlimit="10"
      />
      <path
        d="M487.851 284.046H497.824"
        stroke="#D3D3D3"
        stroke-width="4"
        stroke-miterlimit="10"
      />
      <path
        d="M562.744 249.686H507.224C506.12 249.686 505.224 250.581 505.224 251.686V324.726C505.224 325.831 506.12 326.726 507.224 326.726H562.744C563.849 326.726 564.744 325.831 564.744 324.726V251.686C564.744 250.581 563.849 249.686 562.744 249.686Z"
        fill="#C6C6C6"
      />
      <path
        d="M534.024 298.886C540.784 298.886 546.264 293.406 546.264 286.646C546.264 279.886 540.784 274.406 534.024 274.406C527.264 274.406 521.784 279.886 521.784 286.646C521.784 293.406 527.264 298.886 534.024 298.886Z"
        fill="#D3D3D3"
      />
      <path
        d="M539.695 275.805C541.637 277.928 542.768 280.668 542.89 283.542C543.011 286.417 542.115 289.242 540.359 291.521C538.603 293.8 536.1 295.387 533.289 296.003C530.479 296.619 527.541 296.224 524.993 294.888C526.197 296.208 527.676 297.249 529.325 297.937C530.974 298.624 532.754 298.942 534.539 298.868C536.324 298.794 538.071 298.33 539.658 297.509C541.244 296.687 542.632 295.528 543.722 294.112C544.813 292.697 545.58 291.06 545.97 289.316C546.359 287.572 546.363 285.764 545.979 284.019C545.595 282.274 544.833 280.634 543.748 279.215C542.662 277.796 541.279 276.632 539.695 275.805Z"
        fill="white"
      />
      <path
        d="M322.996 416.607H223.973C223.572 416.607 223.181 416.486 222.85 416.262C222.518 416.037 222.262 415.718 222.114 415.346C221.966 414.974 221.933 414.566 222.02 414.175C222.106 413.784 222.308 413.428 222.599 413.153L225.208 410.688C229.546 406.588 233.002 401.646 235.364 396.164C237.726 390.682 238.944 384.776 238.944 378.807H308.024C308.024 384.776 309.243 390.682 311.605 396.164C313.967 401.646 317.423 406.588 321.761 410.688L324.37 413.153C324.661 413.428 324.862 413.784 324.949 414.175C325.035 414.566 325.002 414.974 324.854 415.346C324.706 415.718 324.45 416.037 324.119 416.262C323.788 416.486 323.396 416.607 322.996 416.607ZM483.664 277.767H487.852V300.327H483.664C480.673 300.327 477.804 299.138 475.688 297.023C473.573 294.907 472.384 292.038 472.384 289.047C472.384 286.055 473.573 283.186 475.688 281.07C477.804 278.955 480.673 277.767 483.664 277.767Z"
        fill="#D3D3D3"
      />
      <path
        d="M539.097 289.301C540.563 289.301 541.752 288.112 541.752 286.646C541.752 285.18 540.563 283.991 539.097 283.991C537.631 283.991 536.442 285.18 536.442 286.646C536.442 288.112 537.631 289.301 539.097 289.301Z"
        fill="#E8E8E8"
      />
      <path
        d="M528.952 289.301C530.418 289.301 531.607 288.112 531.607 286.646C531.607 285.18 530.418 283.991 528.952 283.991C527.486 283.991 526.297 285.18 526.297 286.646C526.297 288.112 527.486 289.301 528.952 289.301Z"
        fill="#E8E8E8"
      />
      <path
        d="M58.4109 364.871H90.7139"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M58.4109 374.181H90.7139"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M58.4109 383.492H90.7139"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M308.849 119.521H341.151"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M308.849 128.831H341.151"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M308.849 138.142H341.151"
        stroke="#E2E2E2"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M107.146 157.035C116.219 157.035 123.574 149.68 123.574 140.607C123.574 131.534 116.219 124.179 107.146 124.179C98.0731 124.179 90.718 131.534 90.718 140.607C90.718 149.68 98.0731 157.035 107.146 157.035Z"
        fill="#E2E2E2"
      />
      <path
        d="M107.812 115.669C112.538 115.669 116.369 111.838 116.369 107.112C116.369 102.386 112.538 98.5549 107.812 98.5549C103.086 98.5549 99.2549 102.386 99.2549 107.112C99.2549 111.838 103.086 115.669 107.812 115.669Z"
        fill="#E2E2E2"
      />
      <path
        d="M164.807 119.518C168.897 119.518 172.213 116.202 172.213 112.112C172.213 108.022 168.897 104.706 164.807 104.706C160.717 104.706 157.401 108.022 157.401 112.112C157.401 116.202 160.717 119.518 164.807 119.518Z"
        fill="#E2E2E2"
      />
      <path
        d="M137.863 109.851C140.589 109.851 142.799 107.641 142.799 104.915C142.799 102.189 140.589 99.979 137.863 99.979C135.137 99.979 132.927 102.189 132.927 104.915C132.927 107.641 135.137 109.851 137.863 109.851Z"
        fill="#E2E2E2"
      />
      <path
        d="M143.599 143.691C150.134 143.691 155.432 138.393 155.432 131.858C155.432 125.323 150.134 120.025 143.599 120.025C137.064 120.025 131.766 125.323 131.766 131.858C131.766 138.393 137.064 143.691 143.599 143.691Z"
        fill="#E2E2E2"
      />
      <path
        d="M516.971 203.551C526.044 203.551 533.399 196.196 533.399 187.123C533.399 178.05 526.044 170.695 516.971 170.695C507.898 170.695 500.543 178.05 500.543 187.123C500.543 196.196 507.898 203.551 516.971 203.551Z"
        fill="#E2E2E2"
      />
      <path
        d="M482.2 203.777C486.926 203.777 490.757 199.946 490.757 195.22C490.757 190.494 486.926 186.663 482.2 186.663C477.474 186.663 473.643 190.494 473.643 195.22C473.643 199.946 477.474 203.777 482.2 203.777Z"
        fill="#E2E2E2"
      />
      <path
        d="M482.2 172.414C488.735 172.414 494.033 167.116 494.033 160.581C494.033 154.046 488.735 148.748 482.2 148.748C475.665 148.748 470.367 154.046 470.367 160.581C470.367 167.116 475.665 172.414 482.2 172.414Z"
        fill="#E2E2E2"
      />
      <path
        d="M521.784 407.306C530.857 407.306 538.212 399.951 538.212 390.878C538.212 381.805 530.857 374.45 521.784 374.45C512.711 374.45 505.356 381.805 505.356 390.878C505.356 399.951 512.711 407.306 521.784 407.306Z"
        fill="#E2E2E2"
      />
      <path
        d="M489.197 414.712C493.287 414.712 496.603 411.396 496.603 407.306C496.603 403.216 493.287 399.9 489.197 399.9C485.107 399.9 481.791 403.216 481.791 407.306C481.791 411.396 485.107 414.712 489.197 414.712Z"
        fill="#E2E2E2"
      />
      <path
        d="M480.118 390.878C486.653 390.878 491.951 385.58 491.951 379.045C491.951 372.51 486.653 367.212 480.118 367.212C473.583 367.212 468.285 372.51 468.285 379.045C468.285 385.58 473.583 390.878 480.118 390.878Z"
        fill="#E2E2E2"
      />
      <path
        d="M415.504 199.424C435.222 199.424 451.206 183.44 451.206 163.722C451.206 144.004 435.222 128.02 415.504 128.02C395.786 128.02 379.802 144.004 379.802 163.722C379.802 183.44 395.786 199.424 415.504 199.424Z"
        fill="#C6C6C6"
      />
      <path
        d="M415.505 141.974H415.504C414.477 141.974 413.645 142.806 413.645 143.833V173.139C413.645 174.166 414.477 174.998 415.504 174.998H415.505C416.532 174.998 417.364 174.166 417.364 173.139V143.833C417.364 142.806 416.532 141.974 415.505 141.974Z"
        fill="#E8E8E8"
      />
      <path
        d="M415.504 187.123C419.991 187.123 419.998 180.15 415.504 180.15C411.017 180.15 411.01 187.123 415.504 187.123Z"
        fill="#E8E8E8"
      />
    </svg>
  );
}

export default NotFoundImage;
